import React from "react";
import GavelOutlinedIcon from "@mui/icons-material/GavelOutlined";
import { Link } from "react-router-dom";
import { useGetCmsQuery } from "../../services/auth";
import { PageHero, LoadingState, ErrorState, EmptyState } from "./PublicShared";
import "./PublicPages.scss";

export default function TermsAndConditions() {
  const { data: cmsData, isLoading, isError, refetch } = useGetCmsQuery();

  const termsContent = cmsData?.data?.terms_and_conditions?.trim();
  const updatedAt = cmsData?.data?.updated_at;

  return (
    <div className="public_page_container">
      <PageHero
        badge="Legal & Terms"
        badgeIcon={<GavelOutlinedIcon />}
        title="Terms & Conditions"
        subtitle="Please read these terms and conditions carefully before using the It's My Wall design platform."
        updatedAt={updatedAt}
      />

      <div className="public_card_container">
        {isLoading ? (
          <LoadingState lines={8} />
        ) : isError ? (
          <ErrorState
            title="Unable to load Terms & Conditions"
            message="We were unable to retrieve the latest terms from our servers. Please check your connection and try again."
            onRetry={refetch}
          />
        ) : !termsContent ? (
          <EmptyState
            title="No Terms & Conditions Published"
            message="The terms and conditions document is currently being revised. Please check back later."
          />
        ) : (
          <>
            <div
              className="public_doc_body"
              dangerouslySetInnerHTML={{ __html: termsContent }}
            />

            <div className="faq_support_cta" style={{ marginTop: 36 }}>
              <div className="cta_text">
                <h4>Need clarification on our terms?</h4>
                <p>
                  Reach out to our customer support desk for any inquiries about licensing or account terms.
                </p>
              </div>
              <Link to="/public/support" className="cta_btn">
                Contact Support
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
